import { onUnmounted, ref } from 'vue'

export function useDelayedLoading(delayMs = 300) {
  const timeout = ref<ReturnType<typeof setTimeout> | null>(null);
  const isLoading = ref<boolean>(false);

  function startLoading() {
    timeout.value = setTimeout(() => {
      isLoading.value = true;
    }, delayMs);
  }

  function stopLoading() {
    if (!timeout.value) {
      return;
    }
    clearTimeout(timeout.value);
    isLoading.value = false;
    timeout.value = null;
  }

  onUnmounted(() => {
    stopLoading();
  });

  return {
    isLoading,
    startLoading,
    stopLoading,
  };
}
